import { autoinject, BindingEngine, customElement, newInstance, computedFrom } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ValidationController, ValidationRules } from 'aurelia-validation';
import { BootstrapGroupRenderer } from 'framework/aurelia_tools/bootstrap-group-renderer';
import { cloneDeep } from 'framework/script_utilities/object-equalizer';
import { ModelBase } from 'support/base_classes/model-base';
import { DeviationTeamRegionDirectorDataModel, DeviationTeamRegionDirectorModel } from 'model/forms/deviation-team-region-director-model';
import { LookupsService } from 'services/lookups-service';

@autoinject
@customElement('deviation-team-region-director-panel')
export class DeviationTeamRegionDirectorPanelCustomElement extends ModelBase<DeviationTeamRegionDirectorDataModel> {
  @bindable controlModel: DeviationTeamRegionDirectorModel = null;
  backup: DeviationTeamRegionDirectorDataModel = null;

  constructor(private lookups: LookupsService, bindingEngine: BindingEngine, @newInstance() private validationController: ValidationController, validationRenderer: BootstrapGroupRenderer) {
    super(bindingEngine);
    this.validationController.addRenderer(validationRenderer);
  }

  bind() {
    this.controlModel.validationController = this.validationController;
    this.model = this.controlModel.data;
    super.bind();
    this.backup = cloneDeep(this.model);
    this.controlModel.rebindData = (data: DeviationTeamRegionDirectorDataModel) => {
      this.controlModel.data = data;
      this.model = this.controlModel.data;
      this.backup = cloneDeep(this.model);
    };
    this.controlModel.cancelChanges = () => {
      this.controlModel.rebindData(this.backup);
    }
  }

  modelChanged(newValue: DeviationTeamRegionDirectorDataModel) {
    super.modelChanged(newValue);
    ValidationRules
      .ensureObject<DeviationTeamRegionDirectorDataModel>().required()
      .ensure(model => model.region).displayName('Region').required()
      .ensure(model => model.director).displayName('Director').required()
      .on(this.model);
    this.validationController.reset();
  }

  @computedFrom('model.director')
  get userGroupLabel() {
    return ['Director / bp employee name', this.model.director?.mail, this.model.director?.phone].filter(l => l != null);
  }

  usersLookupOptions = this.lookups.getUsersLookupOptions();
}
